import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faBars,
  faKeyboard,
  faTachometerAlt,
  faFile,
  faFolder,
  faCog,
  faWrench,
  faUser,
  faSignOutAlt,
  faUsers,
  faChevronRight,
  faChevronLeft,
  faCogs,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faBars,
  faKeyboard,
  faTachometerAlt,
  faFile,
  faFolder,
  faCog,
  faWrench,
  faUser,
  faSignOutAlt,
  faUsers,
  faChevronRight,
  faChevronLeft,
  faCogs
);
